import React, { Component } from 'react';
import Aux from '../../../hoc/auxiliary/auxiliary';
import classes from './HypnosisShowMenu.module.scss'
// import classes2 from '../ExperienceMenu/ExperienceMenu.module.scss'
import HypnosisShow from '../../../assets/Images/Blank.png'
import HypnosisShowStart from '././HypnosisShowStarts'
import Fullpage, { FullPageSections, FullpageSection } from '@ap.cx/react-fullpage'

class HypnosisShowBackSeat extends Component {

    state = {
        backSeat: true,
        showBegins: false,
    }

    showBeginsHandler = () => {
        this.setState({ backSeat: false, showBegins: true })
    }

    render() {
        let HypnosisShowForm = null
        if (this.state.backSeat) {
            HypnosisShowForm = (
                <html style={{ backgroundImage: `url(${HypnosisShow})` }}>
                <div className={classes.storyFrom}>
                    <p>
                    Taking a seat at the back you get a better view of everything happening around you. <br></br>
                    Looking up you see a guy adjusting the light on the stage while two ladies on each side, in what appears to be a magician or magician assistant outfit either dimming the candle lights or diminishing them completely. 
                    While waiting you feel your heart beating a beat faster in anticipation, getting excited watching these final preparations. Feeling goosebumps & butterflies. Thinking to yourself <br></br>
                    <i>"What if I actually get hypnotized?"</i><br></br>
                    You don't have time to think any further about it as you hear someone grabbing the mic and saying <br></br> 
                    “Please be seated, the show is about to start” 
                    </p>
                    <form className={classes.centered} onClick={this.showBeginsHandler}>
                        <h3 className={classes.storyButtonSize}>The Show Begins</h3>
                    </form>
                    </div>
                </html>
                )
        }
        if(this.state.showBegins){
            HypnosisShowForm = (
                <HypnosisShowStart seating = {2}/>
            )
        }

        return (
            <Aux>
                <Fullpage >
                    <FullPageSections>
                        <FullpageSection>
                            {HypnosisShowForm}
                        </FullpageSection>
                    </FullPageSections>
                </Fullpage >

            </Aux >




        )
    }
}


export default HypnosisShowBackSeat